import { createI18n } from 'vue-i18n'
import IntlMessageFormat from 'intl-messageformat'
import zhCN from './modules/zh-CN'
import enUS from './modules/en-US'
import ptBR from './modules/pt-BR'

// Only load zh-CN in development environment
const messages = {
  'en-US': enUS,
  'pt-BR': ptBR,
}

// Development environment includes Chinese locale
if (import.meta.env.MODE === 'development') {
  messages['zh-CN'] = zhCN
}

const i18n = createI18n({
  legacy: false,
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages,
  globalInjection: true, // 全局注入 $t 函数
  datetimeFormats: {}, // 格式化日期
  numberFormats: {}, // 格式化数字
  messageCompiler: (message, { locale, key, onError }) => {
    if (typeof message === 'string') {
      const formatter = new IntlMessageFormat(message, locale)

      return (ctx) => {
        return formatter.format(ctx.values)
      }
    } else {
      onError && onError(new Error('not support for AST'))
      return () => key
    }
  },
})

export function t(...args) {
  return i18n.global.t(...args)
}

/**
 * 辅助函数：处理带数字映射的复数翻译
 * @param {string} key - 翻译键名
 * @param {number} count - 数量
 * @param {object} params - 额外参数（可选）
 * @returns {string} 翻译结果
 *
 * @example
 * // 基础用法（自动传递 count 参数）
 * tPlural('product.onlyLimitTimes', 3) // "Only three times"
 *
 * // 自定义参数名
 * tPlural('common.days', 5, { days: 5 }) // "5 days"
 */
export function tPlural(key, count, params = {}) {
  const mappedKey = `${key}.${count}`

  // 从 key 中提取参数名（例如 "common.days" -> "days"）
  const keyParts = key.split('.')
  const paramName = keyParts[keyParts.length - 1]

  // 合并参数：优先使用传入的 params，否则使用 { [paramName]: count, count }
  const mergedParams = {
    [paramName]: count,
    count,
    ...params,
  }

  // 尝试获取特定数字的翻译
  if (i18n.global.te(mappedKey)) {
    return i18n.global.t(mappedKey, mergedParams)
  }

  // 回退到 other
  return i18n.global.t(`${key}.other`, mergedParams)
}

export default i18n
